/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CatalogEntry,
  CatalogEntry$inboundSchema,
  CatalogEntry$Outbound,
  CatalogEntry$outboundSchema,
} from "./catalogentry.js";

export type CatalogListResponse = {
  object: "list";
  currency: string | null;
  data: Array<CatalogEntry>;
};

/** @internal */
export const CatalogListResponse$inboundSchema: z.ZodType<
  CatalogListResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  currency: z.nullable(z.string()),
  data: z.array(CatalogEntry$inboundSchema),
});
/** @internal */
export type CatalogListResponse$Outbound = {
  object: "list";
  currency: string | null;
  data: Array<CatalogEntry$Outbound>;
};

/** @internal */
export const CatalogListResponse$outboundSchema: z.ZodType<
  CatalogListResponse$Outbound,
  z.ZodTypeDef,
  CatalogListResponse
> = z.object({
  object: z.literal("list"),
  currency: z.nullable(z.string()),
  data: z.array(CatalogEntry$outboundSchema),
});

export function catalogListResponseToJSON(
  catalogListResponse: CatalogListResponse,
): string {
  return JSON.stringify(
    CatalogListResponse$outboundSchema.parse(catalogListResponse),
  );
}
export function catalogListResponseFromJSON(
  jsonString: string,
): SafeParseResult<CatalogListResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CatalogListResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CatalogListResponse' from JSON`,
  );
}
